import { render, staticRenderFns } from "./SelectTab.vue?vue&type=template&id=c3c6fca4&scoped=true"
import script from "./SelectTab.vue?vue&type=script&lang=js"
export * from "./SelectTab.vue?vue&type=script&lang=js"
import style0 from "./SelectTab.vue?vue&type=style&index=0&id=c3c6fca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c6fca4",
  null
  
)

export default component.exports